import { render, staticRenderFns } from "./HeroRegistration.vue?vue&type=template&id=93e59088"
import script from "./HeroRegistration.vue?vue&type=script&lang=js"
export * from "./HeroRegistration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports